import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Icon({ className, children, item }) {
    const { icon = {}, attr = {} } = item;
    const { icon: iconArgs } = icon;
    const Component = attr.href ? 'a' : 'span';

    return (
        <Component className={`dorik-icon ${className}`}>
            {iconArgs && (
                <FontAwesomeIcon
                    fixedWidth
                    className="icon"
                    icon={[iconArgs.prefix, iconArgs.iconName]}
                />
            )}
        </Component>
    );
}

export default React.memo(Icon);
